import { get } from 'lodash'

import type { Contract, DimensionOrEntitlementKey } from '../types'
import { meteringCheck } from './meteringCheck'

export const shouldIncludeMetering = (
  contract: Contract,
  keyName: DimensionOrEntitlementKey,
  shouldCheckAdditional?: boolean
) => {
  const meteringRows = get(contract, keyName)?.rows || []
  return meteringRows.some(row => meteringCheck(row, shouldCheckAdditional))
}
